import PropTypes from 'prop-types';
import Image from '../image/Image';
import styles from './genericMessage.module.less';

// This is not meant to be used directly by any other files than the specific info messages.

const GenericMessage = ({
    className = '',
    containerStyle = '',
    iconContainerClass = '',
    icon = '',
    iconStyle = '',
    textStyle = '',
    children = null,
    column = false,
}) => (
    <div className={[styles.messageContainer, `${!!column && styles.columnMode}`, containerStyle, className].join(' ')}>
        {icon && (
            <div className={[styles.iconContainer, iconContainerClass].join(' ')}>
                <Image
                    src={`message-icon/${icon}.svg`}
                    className={[styles.icon, iconStyle].join(' ')}
                    role={'presentation'}
                />
            </div>
        )}
        <div className={[styles.messageText, textStyle].join(' ')}>{children}</div>
    </div>
);

GenericMessage.propTypes = {
    icon: PropTypes.string.isRequired,
    iconStyle: PropTypes.string.isRequired,
    containerStyle: PropTypes.string.isRequired,
    textStyle: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default GenericMessage;
